// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import { isAdmin } from '../utils/adminConfig';

const AdminRoute = ({ children }) => {
  const { user, userData, loading } = useUser();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-slate-50 via-blue-50 to-indigo-50">
        <div className="text-center">
          <div className="text-4xl mb-4">🔒</div>
          <div className="text-xl text-gray-700">Verifying access...</div>
        </div>
      </div>
    );
  }

  if (!user || !userData || !isAdmin(userData.role)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default AdminRoute;
